export default {
    // Header Section
    "discover_your": "Discover Your",
    "career_path": "Career Path",
    "professional_destiny_analysis": "Professional Destiny Analysis",
    "career_report_description": "Unlock your professional potential with comprehensive career analysis based on Vedic astrology. Get insights into ideal career paths, business prospects, timing for career changes, and strategies for professional success.",

    // Service Information
    "enter_details_for_career_analysis": "Enter Your Details for Career Analysis",
    "complete_career_analysis": "Complete Career Analysis",
    "service_price": "Service Price",
    "comprehensive_career_analysis_note": "In-depth analysis of your professional potential and career roadmap",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "name_career_influence": "Your name influences your professional reputation and success patterns",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "birth_date_career_path": "Essential for determining your career-oriented planetary positions",
    "time_of_birth": "Time of Birth",
    "exact_time_critical_for_career": "Precise time needed for accurate career house calculations",
    "place_of_birth": "Place of Birth",
    "place_of_birth_placeholder": "City, State, Country",
    "location_essential_for_career": "Location affects planetary positions influencing career",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your career analysis will be delivered in the selected language",

    // Core Career Features
    "ideal_career_paths": "Ideal Career Paths",
    "professional_strengths_analysis": "Professional Strengths Analysis",
    "business_prospects_guidance": "Business Prospects Guidance",
    "career_timing_predictions": "Career Timing Predictions",
    "skill_development_recommendations": "Skill Development Recommendations",
    "pdf_download": "Comprehensive PDF Report",

    "what_you_get": "What Your Career Analysis Includes",
    "detailed_career_roadmap": "Detailed Career Roadmap",
    "professional_strengths_weaknesses": "Professional Strengths & Weaknesses",
    "business_entrepreneurship_guidance": "Business & Entrepreneurship Guidance",
    "career_transition_timing": "Career Transition Timing",

    // Actions & Buttons
    "pay_and_generate_analysis": "Get My Career Analysis",
    "processing_payment": "Processing Payment",
    "processing_request": "Generating Analysis",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "career_analysis_processing": "Your career analysis is being prepared by our expert Vedic astrologers. You'll receive detailed insights into your professional potential and ideal career paths.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "delivery_time": "Analysis Delivery",
    "within_12_hours_delivery_note": "Your detailed career report will be ready within 12 hours",
    "whatsapp_notification": "WhatsApp Updates",
    "whatsapp_delivery_note": "Receive instant notifications on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Complete analysis delivered to",

    // What You'll Receive
    "what_youll_receive": "Your Career Analysis Package",
    "detailed_career_report": "Comprehensive Career Report (PDF)",
    "suitable_career_options": "Suitable Career Options & Fields",
    "professional_development_plan": "Professional Development Plan",
    "success_timing_analysis": "Success Timing Analysis",
    "entrepreneurship_assessment": "Entrepreneurship Assessment",

    // Visual Content
    "sample_career_analysis": "Sample Career Analysis",
    "ideal_career_field": "Ideal Career Field",
    "sample_career_description": "Technology & Innovation - Strong analytical and leadership abilities",
    "sample_career_preview": "Preview of your personalized career analysis with field recommendations",
    "career_fields": "Career Fields",

    // Career Field Types
    "technology": "Technology",
    "healthcare": "Healthcare",
    "finance": "Finance",
    "creative_arts": "Creative Arts",
    "education": "Education",
    "business": "Business",

    // Status & Processing
    "your_career_analysis_status": "Your Career Analysis Status",
    "processing_your_analysis": "Analyzing Your Career Potential", 
    "analysis_processing_message": "Our Vedic astrology experts are studying your planetary positions to determine your ideal career path and professional timing.",
    "request_id": "Analysis ID",
    "status": "Status",
    "processing": "In Progress",
    "pending": "Queued",
    "email_notification_sent": "Confirmation email sent",
    "whatsapp_update_coming": "WhatsApp updates enabled",
    "delivery_within_12_hours": "Report ready within 12 hours",

    // Support & Contact
    "contact_support": "Contact Career Support",
    "need_help": "Need guidance?",
    "contact_us_at": "Reach us at",

    // Error Messages
    "please_fill_all_required_fields": "Please complete all required details",
    "payment_failed": "Payment unsuccessful. Please try again.",
    "processing_failed": "Analysis processing failed. Contact our support team.",

    // Career-Specific Elements
    "tenth_house": "10th House (Career House)",
    "ascendant_lord": "Ascendant Lord",
    "career_planets": "Career-Influencing Planets",
    "professional_dasha": "Professional Dasha Periods",
    "career_yogas": "Career Yogas",
    "success_indicators": "Success Indicators",

    // Career Analysis Sections
    "natural_talents": "Natural Talents & Abilities",
    "professional_personality": "Professional Personality",
    "leadership_qualities": "Leadership Qualities",
    "work_preferences": "Work Environment Preferences",
    "career_motivations": "Career Motivations",
    "professional_challenges": "Professional Challenges",

    // Suitable Career Paths
    "recommended_careers": "Recommended Career Paths",
    "alternative_careers": "Alternative Career Options",
    "avoid_careers": "Careers to Avoid",
    "freelancing_potential": "Freelancing Potential",
    "government_vs_private": "Government vs Private Sector",
    "international_opportunities": "International Career Opportunities",

    // Business & Entrepreneurship
    "business_acumen": "Business Acumen",
    "entrepreneurial_skills": "Entrepreneurial Skills",
    "partnership_compatibility": "Business Partnership Compatibility",
    "investment_timing": "Investment Timing",
    "business_sectors": "Suitable Business Sectors",
    "startup_potential": "Startup Success Potential",

    // Professional Development
    "skill_enhancement": "Skill Enhancement Areas",
    "educational_recommendations": "Educational Recommendations",
    "certification_suggestions": "Certification Suggestions",
    "mentorship_guidance": "Mentorship Guidance",
    "networking_strategies": "Networking Strategies",
    "personal_branding": "Personal Branding Tips",

    // Career Timing
    "career_growth_periods": "Career Growth Periods",
    "job_change_timing": "Optimal Job Change Timing",
    "promotion_periods": "Promotion Favorable Periods",
    "salary_negotiation_timing": "Salary Negotiation Timing",
    "business_launch_timing": "Business Launch Timing",
    "retirement_planning": "Retirement Planning Guidance",

    // Success Strategies
    "professional_networking": "Professional Networking",
    "workplace_relationships": "Workplace Relationships",
    "conflict_resolution": "Conflict Resolution Skills",
    "stress_management": "Professional Stress Management",
    "work_life_balance": "Work-Life Balance",
    "career_setback_recovery": "Career Setback Recovery",

    // Financial Aspects
    "earning_potential": "Earning Potential",
    "wealth_accumulation": "Wealth Accumulation Patterns",
    "financial_planning": "Financial Planning Advice",
    "investment_guidance": "Investment Guidance",
    "passive_income_opportunities": "Passive Income Opportunities",
    "financial_security_timing": "Financial Security Timeline",

    // Industry-Specific Guidance
    "it_software": "IT & Software",
    "banking_finance": "Banking & Finance",
    "healthcare_medical": "Healthcare & Medical",
    "education_training": "Education & Training",
    "media_entertainment": "Media & Entertainment",
    "manufacturing_engineering": "Manufacturing & Engineering",
    "sales_marketing": "Sales & Marketing",
    "consulting_services": "Consulting & Services",

    // Professional Relationships
    "boss_relationships": "Relationships with Superiors",
    "colleague_dynamics": "Colleague Dynamics",
    "team_leadership": "Team Leadership Style",
    "client_relationships": "Client Relationship Management",
    "vendor_partnerships": "Vendor & Partnership Management",

    // Career Remedies
    "career_remedies": "Career Enhancement Remedies",
    "professional_gemstones": "Professional Gemstones",
    "career_mantras": "Career Success Mantras",
    "workplace_vastu": "Workplace Vastu Tips",
    "professional_colors": "Professional Lucky Colors",
    "career_fasting": "Career-Beneficial Fasting"
};
